<template>
    <div>
        <v-card>
            <v-card-title>
                <v-icon color="primary">
                    {{
                        planType == 0
                            ? "mdi-alpha-s-box-outline"
                            : "mdi-alpha-p-box-outline"
                    }}
                </v-icon>
                <span class="pl-2 pr-2">{{ planType == 0 ? $t('nav_items.school_plans') : $t('nav_items.parent_plans') }}</span>
                <info-tool-tip
                    :message="$t('plans.coin_tip')"
                ></info-tool-tip>
                <v-spacer></v-spacer>
                <create-button @create="showCreatePlansDialog"></create-button>
            </v-card-title>
            <v-data-table
                item-key="id"
                :loading="isLoading"
                :loading-text="$t('common.loading_wait')"
                :headers="headers"
                :items="plans"
                :search="search"
             :no-data-text="$t('common.no_data')">
                <template v-slot:top>
                    <v-text-field
                        v-model="search"
                        :label="$t('common.search')"
                        class="mx-4"
                    ></v-text-field>
                </template>
                <template v-slot:item.availability="{ item }">
                    <v-chip
                        :color="getAvailabilityColor(item.availability)"
                        dark
                    >
                        {{ getAvailabilityValue(item.availability) }}
                    </v-chip>
                </template>
                <template v-slot:item.created_at="{ item }">
                    <small>{{ item.created_at | moment("LL") }}</small> -
                    <small class="text-muted">{{
                        item.created_at | moment("LT")
                    }}</small>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="editPlan(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon
                        small
                        @click="deletePlan(item, plans.indexOf(item))"
                    >
                        mdi-delete
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>
        <v-row justify="center">
            <v-dialog v-model="planDialog" persistent max-width="700px">
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card>
                        <v-card-title>
                            <span class="text-h5">{{ $t('plans.data_title') }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            v-model="name"
                                            :rules="nameRules"
                                            :label="`${$t('plans_table.name')}*`"
                                            :hint="$t('plans.name_hint')"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            v-model="coin_count"
                                            :rules="coinRules"
                                            :label="`${$t('plans_table.coins')}*`"
                                            :hint="$t('plans.coins_hint')"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            v-model="price"
                                            :rules="priceRules"
                                            :label="`${$t('plans_table.price')}*`"
                                            :hint="$t('plans.price_hint')"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select
                                            v-model="availability"
                                            :items="availability_types"
                                            :rules="[v => !!v || $t('plans.availability_required')]"
                                            :label="$t('plans_table.availability')"
                                            required
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="planDialog = false"
                            >
                                {{ $t('common.close') }}
                            </v-btn>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="createPlan"
                            >
                                {{ $t('common.save') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import InfoToolTip from "@/components/InfoToolTip";
import CreateButton from "@/components/CreateButton";
import auth from '@/services/AuthService';
export default {
    components: {
        InfoToolTip,
        CreateButton,
    },
    data() {
        return {
            plans: [],
            planType: "",
            availability: null,
            availableDrivers: [],
            isLoading: false,
            search: "",
            planDialog: false,
            valid: true,
            id: null,
            planTypeName: "",
            selectedPlan: null,
            name: "",
            nameRules: [
                (v) => !!v || this.$t('plans.name_required'),
                (v) =>
                    (v && v.length <= 15) ||
                    this.$t('plans.name_too_long'),
            ],
            coin_count: "",
            coinRules: [
                (v) => /^[0-9]+$/.test(v) || this.$t('plans.coins_invalid'),
            ],
            price: "",
            priceRules: [(v) => /^[0-9]+$/.test(v) || this.$t('plans.price_invalid')],
            headers: [
                { text: this.$t('plans_table.id'), value: "id", align: "start", filterable: false },
                { text: this.$t('plans_table.name'), value: "name" },
                { text: this.$t('plans_table.coins'), value: "coin_count" },
                { text: this.$t('plans_table.price'), value: "price" },
                { text: this.$t('plans_table.availability'), value: "availability" },
                { text: this.$t('plans_table.created'), value: "created_at" },
                { text: this.$t('plans_table.actions'), value: "actions", sortable: false },
            ],
            availability_types: [
                { text: this.$t('plans_table.one_time'), value: 1 },
                { text: this.$t('plans_table.multiple'), value: 2 },
            ],
        };
    },
    mounted() {
        this.planTypeName = this.$route.name.split("-")[0];
        this.planType = this.planTypeName == "school" ? 0 : 1;
        this.loadPlans();
        //capitalize first letter
        this.planTypeName =
            this.planTypeName.charAt(0).toUpperCase() +
            this.planTypeName.slice(1);
    },
    methods: {
        loadPlans() {
            this.isLoading = true;
            this.plans = [];
            axios
                .get(`/plans/all`, {
                    params: {
                        planType: this.planType,
                    },
                })
                .then((response) => {
                    this.plans = response.data;
                })
                .catch((error) => {
                    this.$notify({
                        title: "",
                        text: this.$t('plans.error_retrieving'),
                        type: "error",
                    });
                    console.log(error);
                    auth.checkError(error.response.data.message, this.$router, this.$swal);
                })
                .then(() => {
                    this.isLoading = false;
                });
        },
        validate() {
            return this.$refs.form.validate();
        },
        createPlan() {
            if (this.validate()) {
                this.isLoading = true;
                this.planDialog = false;
                axios
                    .post(`/plans/create-edit`, {
                        plan: {
                            id: this.id,
                            name: this.name,
                            coin_count: this.coin_count,
                            plan_type: this.planType,
                            price: this.price,
                            availability: this.availability,
                        },
                    })
                    .then((response) => {
                        this.loadPlans();
                        this.$notify({
                            title: "",
                            text: this.id ? this.$t('plans.plan_updated') : this.$t('plans.plan_created'),
                            type: "success",
                        });
                        this.$swal(
                            this.$t('common.success'),
                            this.id ? this.$t('plans.plan_updated') : this.$t('plans.plan_created'),
                            "success"
                        );
                    })
                    .catch((error) => {
                        this.$notify({
                            title: "",
                            text: this.$t('plans.error_creating'),
                            type: "error",
                        });
                        console.log(error);
                        this.$swal(
                            this.$t('common.error'),
                            error.response.data.message,
                            "error"
                        );
                    })
                    .then(() => {
                        this.isLoading = false;
                    });
            }
        },
        showCreatePlansDialog() {
            this.name = "";
            this.coin_count = "";
            this.price = "";
            this.id = null;
            this.availability = null;
            this.planDialog = true;
        },
        editPlan(plan) {
            this.id = plan.id;
            this.name = plan.name;
            this.coin_count = plan.coin_count;
            this.price = plan.price;
            this.availability = plan.availability;
            this.planDialog = true;
        },
        deletePlan(plan, index) {
            this.$swal
                .fire({
                    title: this.$t('plans.delete_plan_title'),
                    text: this.$t('confirmations.delete_plan', { name: plan.name }),
                    icon: "error",
                    showCancelButton: true,
                    confirmButtonText: this.$t('confirmations.delete_confirm'),
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.deletePlanServer(plan.id, index);
                    }
                });
        },
        deletePlanServer(plan_id, index) {
            axios
                .delete(`/plans/${plan_id}`)
                .then((response) => {
                    this.plans.splice(index, 1);
                    this.$notify({
                        title: "",
                        text: this.$t('plans.plan_deleted'),
                        type: "success",
                    });
                })
                .catch((error) => {
                    this.$notify({
                        title: "",
                        text: this.$t('plans.error_deleting'),
                        type: "error",
                    });
                    this.$swal(this.$t('common.error'), error.response.data.message, "error");
                })
                .then(() => {
                    //this.isDeleting = false;
                });
        },
        getAvailabilityColor(availability) {
            return availability == 1 ? "info" : "success";
        },
        getAvailabilityValue(availability) {
            return availability == 1
                ? this.availability_types[0].text
                : this.availability_types[1].text;
        },
    },
};
</script>
